import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Pencil, Loader2 } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

interface EditParentDialogProps {
  parentUserId: string;
  currentName: string;
  currentPhone: string | null;
  onSuccess: () => void;
}

const EditParentDialog = ({ parentUserId, currentName, currentPhone, onSuccess }: EditParentDialogProps) => {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState(currentName);
  const [phone, setPhone] = useState(currentPhone || "");
  const [loading, setLoading] = useState(false);

  const handleOpen = (isOpen: boolean) => {
    if (isOpen) {
      setName(currentName);
      setPhone(currentPhone || "");
    }
    setOpen(isOpen);
  };

  const handleSave = async () => {
    if (!name.trim()) {
      toast.error("الاسم مطلوب");
      return;
    }
    setLoading(true);
    try {
      const { error } = await supabase
        .from("profiles")
        .update({ full_name: name.trim(), phone: phone.trim() || null })
        .eq("user_id", parentUserId);

      if (error) throw error;

      // Update parent_name on linked children
      await supabase
        .from("children")
        .update({ parent_name: name.trim(), parent_phone: phone.trim() || null })
        .eq("parent_id", parentUserId);

      toast.success("تم تحديث بيانات ولي الأمر");
      setOpen(false);
      onSuccess();
    } catch (err: any) {
      toast.error("فشل التحديث: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={handleOpen}>
      <DialogTrigger asChild>
        <Button variant="outline" size="sm" className="text-xs gap-1">
          <Pencil className="w-3 h-3" />
          تعديل
        </Button>
      </DialogTrigger>
      <DialogContent dir="rtl" className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>تعديل بيانات ولي الأمر</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 mt-2">
          <div className="space-y-2">
            <Label>الاسم الكامل</Label>
            <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="اسم ولي الأمر" />
          </div>
          <div className="space-y-2">
            <Label>رقم الهاتف</Label>
            <Input value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="05xxxxxxxx" dir="ltr" />
          </div>
          <Button onClick={handleSave} disabled={loading} className="w-full">
            {loading ? <Loader2 className="w-4 h-4 animate-spin ml-2" /> : null}
            حفظ التعديلات
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default EditParentDialog;
